import { useEffect, useState } from 'react';
import { useApi } from '../../../../hooks/useApi';
import { collectFeedbackNow, loadFeedbackStatus, saveFeedbackSettings } from '../../../../services/feedback';

export default function FeedbackReadiness({ accountId, refreshKey, onOpen }) {
    const { request } = useApi();
    const [status, setStatus] = useState(null);
    const [enabling, setEnabling] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        loadFeedbackStatus({ request, accountId }).then((data) => !cancelled && setStatus(data)).catch(() => {});
        return () => { cancelled = true; };
    }, [request, accountId, refreshKey]);

    if (!status) return null;

    const enable = async () => {
        setEnabling(true);
        try {
            await saveFeedbackSettings({ request, accountId, settings: { enabled: true } });
            await collectFeedbackNow({ request, accountId });
            setStatus(await loadFeedbackStatus({ request, accountId }));
        } finally {
            setEnabling(false);
        }
    };

    const collecting = status.steps.find((step) => step.key === 'collect');
    const needEnable = collecting && collecting.state === 'warn' && collecting.hint.startsWith('Включите');

    if (status.ready && !expanded) {
        return (
            <div className="fb-card fb-row fb-spread" style={{ padding: '8px 14px' }}>
                <span><b>Всё готово к работе.</b> <span className="fb-muted">Агент, плательщик и база знаний в порядке.</span></span>
                <button type="button" onClick={() => setExpanded(true)}>Показать шаги</button>
            </div>
        );
    }

    return (
        <div className="fb-card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="fb-row fb-spread">
                <div>
                    <h4 style={{ margin: 0 }}>{status.ready ? 'Всё готово к работе' : 'Подготовка к работе'}</h4>
                    <div className="fb-muted">{status.ready ? 'Агент, плательщик и база знаний в порядке.' : 'Пройдите шаги, и обращения начнут приходить сами, а ИИ будет готовить ответы.'}</div>
                </div>
                {needEnable && <button type="button" className="primary" disabled={enabling} onClick={enable}>Включить сбор и начать</button>}
            </div>
            <div className="fb-steps">
                {status.steps.map((step) => (
                    <div key={step.key} className={`fb-step fb-step--${step.state}`}>
                        <span className="fb-step__dot" />
                        <div>
                            <div className="fb-step__title">{step.title}</div>
                            {step.hint && <div className="fb-step__hint">{step.hint}</div>}
                            {step.key === 'knowledge' && step.state !== 'ok' && (
                                <button type="button" style={{ marginTop: 6 }} onClick={() => onOpen('knowledge')}>Открыть базу знаний</button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
